import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import locales from './assets/lang/vantLocal.js'
import {
  Button,
  NavBar,
  Dialog,
  Toast,
  Tabbar,
  TabbarItem,
  Popup,
  Form,
  Field,
  Image as VanImage,
  Picker,
  Card,
  PullRefresh,
  List,
  Search,
  Sku,
  Stepper,
  CellGroup,
  Cell,
  SwipeCell,
  Icon,
  Col,
  Row,
  AddressList,
  AddressEdit,
  DropdownMenu,
  DropdownItem,
  Badge,
  Sticky,
  Checkbox,
  RadioGroup,
  Radio,
  Pagination,
  Uploader,
  Empty,
} from 'vant'

// vant组件
Vue.use(Button)
  .use(NavBar)
  .use(Dialog)
  .use(Toast)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Popup)
  .use(Form)
  .use(Field)
  .use(VanImage)
  .use(Picker)
  .use(Card)
  .use(PullRefresh)
  .use(List)
  .use(Search)
  .use(Sku)
  .use(Stepper)
  .use(CellGroup)
  .use(Cell)
  .use(SwipeCell)
  .use(Icon)
  .use(Col)
  .use(Row)
  .use(AddressList)
  .use(AddressEdit)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Badge)
  .use(Sticky)
  .use(Checkbox)
  .use(RadioGroup)
  .use(Radio)
  .use(Pagination)
  .use(Uploader)
  .use(Empty)

Vue.config.productionTip = false

Vue.prototype.$Local = locales

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
